
import { useEffect, useState } from 'react';

interface MotivationalBannerProps {
  show: boolean;
  message?: string;
  onComplete?: () => void;
}

const MotivationalBanner = ({ show, message = "", onComplete }: MotivationalBannerProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    console.log('🎯 MotivationalBanner: Props changed', { show, message: message.substring(0, 30) });
    
    if (show && message && message.trim()) {
      console.log('🟢 MotivationalBanner: Showing banner');
      setIsVisible(true);
      
      // Auto-hide after 2 seconds
      const timer = setTimeout(() => {
        console.log('🟠 MotivationalBanner: Auto-hiding banner');
        setIsVisible(false);
        // Call onComplete after fade animation
        setTimeout(() => {
          console.log('✅ MotivationalBanner: Calling onComplete');
          onComplete?.();
        }, 300);
      }, 2000);
      
      return () => clearTimeout(timer);
    } else {
      console.log('⚪ MotivationalBanner: Hiding banner (show=false or empty message)');
      setIsVisible(false);
    }
  }, [show, message, onComplete]);

  // Don't render if not visible or no message
  if (!isVisible || !message || !message.trim()) {
    return null;
  }

  console.log('🎯 MotivationalBanner: Rendering with message:', message);

  return (
    <div 
      className="fixed top-0 left-0 right-0 pointer-events-none"
      style={{ zIndex: 9999 }}
    >
      <div 
        className="mx-4 mt-4 p-6 rounded-lg shadow-xl text-center"
        style={{
          backgroundColor: '#F58026',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '18px',
          transform: isVisible ? 'translateY(0px)' : 'translateY(-120px)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.3s ease-out',
          border: '2px solid white',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default MotivationalBanner;
